/* SportsHero · Doel-test (goal finder) — question/result toggle.
   All content and matched products are server-rendered per block by
   sections/doel-test.liquid; this only switches which panel is visible. */
(function () {
  function init(root) {
    var question = root.querySelector('[data-finder-question]');
    var triggers = root.querySelectorAll('[data-goal-trigger]');
    var panels = root.querySelectorAll('[data-goal-panel]');
    var restartButtons = root.querySelectorAll('[data-finder-restart]');

    triggers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var goalId = btn.getAttribute('data-goal-trigger');
        panels.forEach(function (panel) {
          panel.classList.toggle('sh-show', panel.getAttribute('data-goal-panel') === goalId);
        });
        if (question) question.hidden = true;
      });
    });

    restartButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        panels.forEach(function (panel) {
          panel.classList.remove('sh-show');
        });
        if (question) question.hidden = false;
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.sh-finder').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
